import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { loadAppConfig, resolveApiBaseUrl } from "./utils/config";

const initI18n = async () => {
  try {
    let supportedLanguages: string[] = ['he', 'en-US'];

    const config = await loadAppConfig();
    const apiBaseUrl = resolveApiBaseUrl(config);

    try {
      const resLang = await fetch(`${apiBaseUrl}languages`);
      const data = await resLang.json();
      if (Array.isArray(data)) {
        supportedLanguages = data
          .filter(lang => lang.statusId && typeof lang.code === 'string')
          .map(lang => lang.code.trim());
      }
    } catch (error) {
      console.error('שגיאה בשליפת שפות מהשרת, משתמשים בברירת מחדל:', error);
    }

    await i18n
      .use(HttpApi)
      .use(LanguageDetector)
      .init({
        supportedLngs: supportedLanguages,
        fallbackLng: 'he',
        detection: {
          order: ['localStorage'],
          caches: ['localStorage']
        },
        backend: {
          loadPath: `${apiBaseUrl}Languages/GetCurrentLocales/client/{{lng}}`,
          // loadPath: '/locales/locale-{{lng}}.json'        
        }
      }
      );

    // טעינת תרגומים מהקבצים המקומיים כגיבוי
    try {
      for (const lang of supportedLanguages) {
        try {
          const localResponse = await fetch(`/locales/locale-${lang}.json`);
          if (localResponse.ok) {
            const localTranslations = await localResponse.json();
            i18n.addResourceBundle(lang, 'translation', localTranslations, true, true);
          }
        } catch (localError) {
          // התעלם משגיאות בטעינת קבצים מקומיים
          console.debug(`לא ניתן לטעון תרגומים מקומיים עבור ${lang}:`, localError);
        }
      }
    } catch (error) {
      console.debug('שגיאה בטעינת תרגומים מקומיים:', error);
    }

  } catch (error) {
    console.error('שגיאה באתחול i18n:', error);
  }
};

export { initI18n };
export default i18n;